import { render } from "./PageNotFoundView.vue?vue&type=template&id=68fe5ce0"
import script from "./PageNotFoundView.vue?vue&type=script&lang=js"
export * from "./PageNotFoundView.vue?vue&type=script&lang=js"

import "./PageNotFoundView.vue?vue&type=style&index=0&id=68fe5ce0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__